<template>
  <main class="mt-5">
    <v-toolbar flat>
      <v-toolbar-title>
        <h2>{{ $t("items") }}</h2>
      </v-toolbar-title>
      <v-spacer />

      <v-col cols="12" md="2">
        <v-btn
          @click="handleClear"
          large
          block
          rounded
          outlined
          color="primary"
          style="border: none"
          >{{ $t("clear") }}</v-btn
        >
      </v-col>
      <v-col cols="12" md="2">
        <v-btn
          @click.prevent="onSubmit"
          :disabled="v.form.$invalid || selected.length === 0"
          large
          block
          rounded
          class="success"
          >{{ $t("Submit") }}</v-btn
        >
      </v-col>
    </v-toolbar>
    <v-data-table
      v-model="selected"
      class="mt-4"
      :headers="headers"
      :items="items"
      :mobile-breakpoint="0"
      :items-per-page="100"
      hide-default-footer
      show-select
      item-key="id"
    >
      <template v-slot:[`item.transfareed_quantity`]="{ item }">
        <number-input
          style="width: 230px; margin: auto"
          center
          v-model="item.on_hand_qty"
          :min="1"
          :max="form.transaction_type === 2 ? 9999999999999 : item.max_on_hande"
          controls
          :step="1"
        ></number-input>
      </template>
    </v-data-table>
    <Pagination :pagination="pagination" />
  </main>
</template>

<script>
import { StoreData } from "@/helpers/apiMethods";
export default {
  name: "ItemsTable",
  components: {
    Pagination: () => import("@/components/Pagination"),
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    pagination: {
      type: Object,
      default: () => {},
    },
    form: {
      type: Object,
      default: () => {},
    },
    v: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      selected: [],
      filterNames: ["locator_id", "inventor", "transaction_type_id"],
    };
  },

  computed: {
    headers() {
      const headers = [
        {
          text: this.$t("table.Select All"),
          align: "left",
          sortable: false,
          value: "select_all",
        },
        {
          text: this.$t("table.Item Code"),
          align: "center",
          sortable: false,
          value: "code",
        },
        {
          text: this.$t("table.Name"),
          align: "center",
          sortable: false,
          value: "name",
        },

        {
          text: this.$t("table.On-hand"),
          align: "center",
          sortable: false,
          value: "max_on_hande",
        },
        {
          text: this.$t("table.Transferred Quantity"),
          align: "center",
          sortable: false,
          value: "transfareed_quantity",
        },
      ];
      return headers;
    },
  },
  methods: {
    onSubmit() {
      const formData = new FormData();
      const form = {
        ...this.form,
        date: `${this.form.date} 00:00:00`,
      };
      for (const key in form) {
        if (form[key] !== "") {
          formData.append(key, form[key]);
        }
      }
      this.selected.forEach((item, index) => {
        formData.append(`items[${index}][id]`, item.id);
        formData.append(`items[${index}][qty]`, item.on_hand_qty);
      });

      StoreData({ reqName: "scm/bulk-transactions", data: formData }).then(
        () => {
          this.$router.push("/scm/transactions");
        }
      );
    },
    handleClear() {
      const query = { ...this.$route.query };
      for (const name of this.filterNames) {
        this.$delete(query, name);
      }
      this.$router.push({ query });
      this.$emit("on-refresh-items");
    },
  },
  watch: {
    items: {
      handler(value) {
        if (value) {
          this.selected = value;
        }
      },
      immediate: true,
    },
  },
};
</script>

